import React from "react";
import { Footer as FlowbiteFooter } from "flowbite-react";
import { UserbackFormButton } from "@/components/parts/UserbackFormButton";
import { FeedbackInvitation } from "@/components/shared/FeedbackInvitation";
import { MENU_CATEGORIES } from "@/constants/Menu";

interface AuthorService {
  name: string;
  description: string;
  url: string;
}

const AUTHOR_SERVICES: readonly AuthorService[] = [
  {
    name: "Kurashi Lab",
    description: "暮らしのお金のシミュレーション",
    url: "https://kurashilab.pages.dev/",
  },
];

const FooterColumn: React.FC<{
  title: string;
  children: React.ReactNode;
}> = ({ title, children }) => {
  return (
    <div>
      <p className="text-xs font-medium text-text">{title}</p>
      <ul className="mt-3 flex flex-col gap-2">{children}</ul>
    </div>
  );
};

export const Footer: React.FC = () => {
  return (
    <FlowbiteFooter container className="bg-background h-auto rounded-none">
      <div className="mx-auto w-full max-w-3xl">
        <nav
          aria-label="サイト内のページ一覧"
          className="grid grid-cols-2 gap-8 text-left md:grid-cols-5"
        >
          {MENU_CATEGORIES.map((category) => (
            <FooterColumn key={category.id} title={category.title}>
              {category.items.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-primary-700 hover:text-primary-500"
                  >
                    {item.title}
                  </a>
                </li>
              ))}
            </FooterColumn>
          ))}
          <FooterColumn title="作者の別サービス">
            {AUTHOR_SERVICES.map((service) => (
              <li key={service.url}>
                <a
                  href={service.url}
                  target="_blank"
                  className="text-sm text-primary-700 hover:text-primary-500"
                >
                  {service.name}
                </a>
                <span className="ml-2 text-xs text-text">
                  {service.description}
                </span>
              </li>
            ))}
          </FooterColumn>
        </nav>
        <div className="mt-8 w-full border-t border-border pt-6">
          <FeedbackInvitation />
        </div>
        <div className="mt-6 w-full">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 sm:justify-end">
            <a
              href="/me/"
              className="text-sm text-primary-600 hover:text-primary-700"
            >
              マイデータ
            </a>
            <a
              href="/terms/"
              className="text-sm text-primary-600 hover:text-primary-700"
            >
              利用規約
            </a>
            <a
              href="/privacy/"
              className="text-sm text-primary-600 hover:text-primary-700"
            >
              プライバシーポリシー
            </a>
            <a
              href="https://www.instagram.com/nekometry/"
              target="_blank"
              rel="noopener"
              className="text-sm text-primary-600 hover:text-primary-700"
            >
              公式Instagram
            </a>
            <UserbackFormButton
              label="お問い合わせ"
              feedbackType="general"
              className="text-sm text-primary-600 hover:text-primary-700"
            />
          </div>
        </div>
        <div className="mt-4 space-y-1 text-center text-xs text-text sm:text-left">
          <p>
            Amazonのアソシエイトとして、Nekometryは適格販売により収入を得ています。
          </p>
          <p>
            商品情報の一部は楽天ウェブサービスから取得しています（
            <a
              href="https://developers.rakuten.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-primary-500"
            >
              Supported by Rakuten Developers
            </a>
            ）。
          </p>
        </div>
      </div>
    </FlowbiteFooter>
  );
};
